import { toast } from "react-toastify";
import { API_BASE_URL } from "./constants";
import { readErrorMessage } from "./apiError";

// The services screens' channels: which contact each one uses
const CHANNELS = {
  email: { type: 3, field: "EMail_id", name: "e-mail", contact: "e-mail id" },
  whatsapp: { type: 2, field: "Mobile_no", name: "WhatsApp", contact: "mobile no." },
  sms: { type: 1, field: "Mobile_no", name: "SMS", contact: "mobile no." },
};

/**
 * Sends one notice per row (the case's document link) over one channel. A row without that contact is skipped and a
 * failed send doesn't stop the others; the summary at the end says how many were sent, skipped and failed (and which).
 * ui: the screen's setLoading / setProgress / setProgressText / setTotal; onDone runs when nothing failed.
 */
export async function sendNoticeBatch({ rows, channel, processId, ui, onDone }) {
  const ch = CHANNELS[channel];
  const sent = [];
  const skipped = [];
  const failed = [];
  ui.setLoading(true);
  ui.setProgress(0);
  ui.setTotal(rows.length);
  for (let i = 0; i < rows.length; i++) {
    const item = rows[i];
    const who = `${item.Reference_no}${item.Cust_name ? ` (${item.Cust_name})` : ""}`;
    ui.setProgress(i + 1);
    ui.setProgressText(`Sending ${i + 1} of ${rows.length}`);
    const address = String(item[ch.field] ?? "").trim();
    if (!address) {
      skipped.push(who);
      continue;
    }
    try {
      const response = await fetch(`${API_BASE_URL}/api/OneService`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Ref_no: item.Reference_no,
          Service_add: address,
          Service_type_id: ch.type,
          Service_id: item.Service_id ?? 0,
          File_path: item.File_path ?? "",
          Process_id: processId,
        }),
      });
      if (!response.ok) throw new Error(await readErrorMessage(response));
      sent.push(who);
    } catch (e) {
      failed.push(`${who}: ${e.message}`);
    }
  }
  ui.setLoading(false);
  setTimeout(() => {
    ui.setProgress(0);
    ui.setProgressText("");
    ui.setTotal(0);
  }, 200);

  const lines = [`${ch.name}: ${sent.length} sent`];
  if (skipped.length) lines.push(`${skipped.length} skipped – no ${ch.contact}: ${skipped.join(", ")}`);
  if (failed.length) lines.push(`${failed.length} failed:\n${failed.join("\n")}`);
  const message = lines.join("\n");
  const options = { theme: "colored", autoClose: failed.length || skipped.length ? false : 3000, style: { whiteSpace: "pre-line" } };
  if (failed.length) toast.error(message, options);
  else if (skipped.length) toast.warning(message, options);
  else toast.success(message, options);
  if (!failed.length && sent.length && onDone) onDone();
  return { sent: sent.length, skipped: skipped.length, failed: failed.length };
}
